import React from 'react';
import Page from '../../components/Page';
import Footer from '../../components/Footer';
import {
    flexContainer,
    listBoxTransparent,
    subTitle,
    title,
    wrapper,
} from './LastPageStyle';
import IndustryArea from '../../components/IndustryArea';

const PlanningLastPage = () => {
    return (
        <Page fixedPageHeight>
            <div className={flexContainer}>
                <div className={title} style={{ fontSize: '20pt' }}>
                    Mit Zellweger Management Consultants zu profitablem Wachstum
                </div>
                <h2>Daten zu profitablem Nutzen transformieren</h2>
                <p>
                    Data Science & AI sind wichtige Enabler für das profitable Wachstum Ihres Unternehmens. Wir sorgen
                    dafür, dass Sie die Möglichkeiten und Potenziale nutzenbringend einsetzen und monetarisieren. Dabei
                    beraten wir Sie und entwickeln kundenspezifische Lösungen.
                </p>
                <div className={wrapper}>
                    <div className={listBoxTransparent}>
                        <div className={subTitle}>Consulting</div>
                        <h3>Data Science & AI-Potenzialfindung</h3>
                        <ul>
                            <li>Startup-Workshop, Visioning, Ideation</li>
                            <li>Reifegrad-Assessment</li>
                            <li>Strategie, Roadmap</li>
                            <li>Use Case Evaluation</li>
                        </ul>
                        <h3>Data Management & Governance</h3>
                        <ul>
                            <li>Data Strategie & Roadmap</li>
                            <li>Data Quality Assessment & Improvement</li>
                            <li>Data Security & Compliance</li>
                            <li>Data Infrastructure & Architecture</li>
                            <li>Data Acquisition</li>
                        </ul>
                        <h3>Integration & Training</h3>
                        <ul>
                            <li>IT-Infrastruktur & Applikationsarchitektur</li>
                            <li>Evaluation von DS & AI-Lösungen, Partner</li>
                            <li>Implementierung von DS & AI-Lösungen</li>
                            <li>Inhouse-Training, Z Academy</li>
                        </ul>
                    </div>
                    <div className={listBoxTransparent}>
                        <div className={subTitle}>Development</div>
                        <h3>Anwendungen für Ihre Produkte & Dienstleistungen</h3>
                        <ul>
                            <li>Condition Monitoring, Predictive Maintenance</li>
                            <li>Parameter Optimisation, Autonomous Adaption</li>
                            <li>Process & Quality Control</li>
                            <li>Anomalies Detection</li>
                            <li>Optimisation of Process Media Consumption</li>
                            <li>Operator Guidance (HMI)</li>
                            <li>Self Servicing</li>
                        </ul>
                        <h3>Anwendungen für Ihre Prozessoptimierung</h3>
                        <ul>
                            <li>Produkt- & Dienstleistungsentwicklung</li>
                            <li>Marketing & Vertrieb</li>
                            <li>Forecasting, S&OP Planung</li>
                            <li>Einkauf</li>
                            <li>Produktion</li>
                            <li>Logistik</li>
                            <li>After Sales Service</li>
                        </ul>
                    </div>
                </div>
                <p style={{ marginBottom: '4mm' }}>
                    Zellweger Management Consultants (ZMC) kombiniert das Fach- und Branchen-Knowhow unserer
                    Berater*innen in den Bereichen «Digitale Geschäftstransformation», «Supply Chain- und Operations
                    Management» sowie «Service» mit der Data Science & AI-Kompetenz unserer Spezialst*innen.{' '}
                </p>
                <h2>Internationale Kunden vertrauen seit über 25 Jahren auf uns</h2>
                <p>
                    Internationale mittelständische Unternehmen kooperieren mit uns als Partner für die nachhaltige
                    profitable Unternehmensentwicklung. Zu unseren Kunden zählen insbesondere auch Private
                    Equity-Unternehmen und Ihre Portfolio-Unternehmen.
                </p>
                <IndustryArea />
                <div style={{ flex: 1 }} />
                <Footer />
            </div>
        </Page>
    );
};

export default PlanningLastPage;
